import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import PosterServices from '../../services/BannerServices';
import MembershipServiceListServices from '../../services/MembershipServiceListServices';

function AddPoster() {
    const navigate = useNavigate();

    const [formValues, setFormValues] = useState({
        serviceId: '',
        title: '',
        image: [], // ✅ always array
    });

    const [previewImages, setPreviewImages] = useState([]);
    const [services, setServices] = useState([]);

    /* ================= FETCH SERVICES ================= */
    useEffect(() => {
        fetchDropdownData();
    }, []);

    const fetchDropdownData = async () => {
        try {
            const res = await MembershipServiceListServices.getServiceGuest();
            const data = res?.data || [];

            const formatted = data.map(item => ({
                _id: item._id,
                title: item.title
            }));

            setServices(formatted);
        } catch (error) {
            console.error(error);
        }
    };

    /* ================= FILE CHANGE ================= */
    const handleFileChange = (e) => {
        const files = Array.from(e.target.files);
        if (!files.length) return;

        // store file (only first file because API needs single)
        setFormValues(prev => ({
            ...prev,
            image: [files[0]] // ✅ only one image
        }));

        // preview
        const preview = URL.createObjectURL(files[0]);
        setPreviewImages([preview]);
    };

    /* ================= REMOVE IMAGE ================= */
    const removeImage = () => {
        setFormValues(prev => ({
            ...prev,
            image: []
        }));
        setPreviewImages([]);
    };

    /* ================= INPUT CHANGE ================= */
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormValues(prev => ({
            ...prev,
            [name]: value
        }));
    };

    /* ================= SUBMIT ================= */
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formValues.serviceId) {
            alert('Select service');
            return;
        }

        if (!formValues.title) {
            alert('Enter title');
            return;
        }

        if (formValues.image.length === 0) {
            alert('Upload image');
            return;
        }

        try {
            const formData = new FormData();

            formData.append("serviceId", formValues.serviceId);
            formData.append("title", formValues.title);
            formData.append("image", formValues.image[0]); // ✅ correct

            const res = await PosterServices.createPoster(formData);

            if (res.status) {
                alert(res.message);
                navigate('/poster-list');
            } else {
                alert(res.message);
            }

        } catch (error) {
            console.error(error);
            alert('Error creating poster');
        }
    };

    return (
        <div className="right_col">
            <div className="title-box">
                <h2>Add Poster</h2>
                <Link to="/poster-list">Poster List</Link>
            </div>

            <div className="container-box px-5">
                <form onSubmit={handleSubmit}>
                    <div className="row">

                        {/* Service */}
                        <div className="col-lg-6 mt-3">
                            <label>Select Service</label>
                            <select
                                name="serviceId"
                                value={formValues.serviceId}
                                onChange={handleInputChange}
                                className="form-control"
                               
                            >
                                <option value="">Select</option>
                                {services.map(s => (
                                    <option key={s._id} value={s._id}>
                                        {s.title}
                                    </option>
                                ))}
                            </select>
                        </div>

                        {/* Title */}
                        <div className="col-lg-6 mt-3">
                            <label>Title</label>
                            <input
                                className="form-control"
                                name="title"
                                value={formValues.title} // ✅ fixed
                                onChange={handleInputChange}
                            
                            />
                        </div>

                        {/* Image */}
                        <div className="col-lg-6 mt-3">
                            <label>Image</label>
                            <input
                                type="file"
                                className="form-control"
                                onChange={handleFileChange}
                                accept="image/*"
                            />

                            {previewImages.length > 0 && (
                                <div className="mt-2">
                                    <img
                                        src={previewImages[0]}
                                        width="80"
                                        height="80"
                                        alt="preview"
                                    />
                                    <button
                                        type="button"
                                        onClick={removeImage}
                                        className="btn btn-danger btn-sm"
                                    >
                                        Remove
                                    </button>
                                </div>
                            )}
                        </div>

                    </div>

                    <button className="submit-green-btn mt-4">
                        SUBMIT
                    </button>
                </form>
            </div>
        </div>
    );
}

export default AddPoster;